import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsString, IsUUID, MaxLength } from 'class-validator';
import { UserDto } from '../../user/dto/user.dto';
import { JobPhaseBumpNoteInterface } from '../interfaces/job-phase-bump-note.interface';
import { JobPhaseBumpDto } from '../../job-phase-bump/dtos/job-phase-bump.dto';
import { JobPhaseBumpInterface } from '../../job-phase-bump/interfaces/job-phase-bump.interface';

@Exclude()
export class JobPhaseBumpNoteDto
  extends CommonEntityDto
  implements JobPhaseBumpNoteInterface
{
  @IsString()
  @MaxLength(1000)
  @ApiProperty({
    title: 'Note',
  })
  @Expose()
  note!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase Bump ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseBumpId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => [JobPhaseBumpDto],
    title: 'Job Phase Bump',
    description: 'The Job Phase Bump associated with this job phase bump note.',
  })
  @Expose()
  jobPhaseBump?: JobPhaseBumpInterface;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this job phase bump note.',
  })
  @Expose()
  user?: UserDto;
}
